import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux'
import allActions from '../../actions'
import { unoTheme } from '../../assets/styles/unoTheme';
import { applyMaskAmount, applyMaskAccount, applyMaskAmountFreeDecimals, checkIsSameBalance, checkIsSameQuotas } from './utils'

import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import { isPrivateCdiTitle } from '../../controllers/TitleController';

const useStyles = makeStyles((theme) => ({

    alertBalance: {
        '& .MuiAlert-message': {
            fontSize: '12px',
            padding: '0px',
            '& span': {
                verticalAlign: 'middle',
            }
        },
        '& .MuiAlert-icon': {
            padding: '0px',
        },
        '& .alertMain': {
            marginTop: '5px',
            marginBottom: '5px',
        }
    },
    bold: {
        color: 'black',
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: unoTheme.errorColor,
    },
    blue: {
        color: 'blue',
    },
}));

const stylesBold = { color: 'black' };
const stylesGreen = { color: unoTheme.greenMoney };
const stylesRed = { color: unoTheme.errorColor };
const stylesBlue = { color: 'blue' };

const difBalances = 0.15;

function renderAccountInline(row) {
    return (
        <span>
            <span style={stylesBold}>Conta: </span>
            <span style={stylesBold}>{applyMaskAccount(row.number_account)} {row.agency ? "/" + row.agency : ""}</span>
        </span>
    );
}

/**
 * Retorna o JSX do alerta de saldo para uso tanto no componente MyAlertBalance
 * quanto em contextos externos (ex: células de tabela).
 * @param {Object} row - linha de dados
 * @param {Function} action - callback chamado ao conciliar
 * @param {string} role - papel do usuário
 * @returns {JSX.Element|null}
 */
export function getAlertBalanceContent(row, action, role) {

    const isBalanceSame = (row.balance_now == row.pl || checkIsSameBalance(row.pl, row.balance_now))
        && (row.quota_amount_now == row.qtd_quotas_sensibilized_final || checkIsSameQuotas(row.quota_amount_now, row.qtd_quotas_sensibilized_final));

    if (isBalanceSame) return null;
    if (row.balance_now_conc) return null;

    const isAdmin = role == "ROLE_ADMIN" || role == "ROLE_SUPER_ADMIN";

    const balanceDiffOk = row.balance_now != undefined && (
        row.pl - row.balance_now >= 0
            ? (row.pl - row.balance_now <= difBalances || isAdmin)
            : (((row.pl - row.balance_now) * (-1)) <= difBalances || isAdmin)
    );

    const quotaDiffOk = row.balance_now != undefined && (
        row.qtd_quotas_sensibilized_final - row.quota_amount_now >= 0
            ? (row.qtd_quotas_sensibilized_final - row.quota_amount_now <= difBalances || isAdmin)
            : (((row.qtd_quotas_sensibilized_final - row.quota_amount_now) * (-1)) <= difBalances || isAdmin)
    );

    const canConciliate = (balanceDiffOk && quotaDiffOk) || (row.special && isAdmin);

    return (
        <Alert
            className={'alertMain'}
            variant="outlined"
            severity="warning"
            action={
                canConciliate && action
                    ? <Button color={"inherit"} size="small" onClick={() => action(row.balance_now_id)}>
                        {'Conciliar'}
                    </Button>
                    : null
            }>

            {renderAccountInline(row)}
            <br />

            {
                row.balance_before == undefined
                    || row.balance_now == undefined
                    || row.quota_amount_before == undefined
                    || row.quota_amount_now == undefined ?

                    <span>É necessário que o SALDO e a QTD DE COTAS (Anterior e atual) sejam informados na tela de Ativos e Contas</span>

                    :

                    <>
                        {
                            row.quota_amount_now == row.qtd_quotas_sensibilized_final || checkIsSameQuotas(row.quota_amount_now, row.qtd_quotas_sensibilized_final) ?

                                <>
                                    {
                                        (row.pl - row.balance_now > 0
                                            ? row.pl - row.balance_now <= difBalances
                                            : ((row.pl - row.balance_now) * (-1)) <= difBalances) ?

                                            <span>
                                                O saldo calculado {'>'} <span style={stylesGreen}>{
                                                    row.balance_before != null ? applyMaskAmountFreeDecimals(row.pl, true) : applyMaskAmountFreeDecimals(row.resultAmount, true)
                                                }</span> está diferente do saldo do extrato {'>'} <span style={stylesGreen}>{applyMaskAmount(row.balance_now, true)}</span>.
                                                <span> ( Dif: </span><span style={stylesRed}>{applyMaskAmountFreeDecimals(row.pl - row.balance_now, false, 5)}</span> )
                                            </span>
                                            :
                                            <span>
                                                O saldo calculado {'>'} <span style={stylesGreen}>{
                                                    row.balance_before != null ? applyMaskAmountFreeDecimals(row.pl, true) : applyMaskAmountFreeDecimals(row.resultAmount, true)
                                                }</span> está diferente do saldo do extrato {'>'} <span style={stylesGreen}>{applyMaskAmount(row.balance_now, true)} </span>além do limite máximo de <span style={stylesBlue}>{applyMaskAmount(difBalances, true)}. </span><span>Consulte o administrador para liberação</span>
                                            </span>
                                    }
                                </>

                                :

                                <div>
                                    <span>A quantidade de cotas informada na validação de saldos para o mês atual está diferente da quantidade de cotas obtidas na sensibilzação </span>
                                    {
                                        Number.isNaN(row.quota_amount_before) ? <div><span style={stylesBlue}>(Saldo de cotas do mês anterior não informado)</span></div>
                                            :
                                            <>
                                                <div>(Validação) Cotas: <span style={stylesGreen}>{applyMaskAmountFreeDecimals(row.quota_amount_now, false, 5)}</span> / Valor: <span style={stylesGreen}> {applyMaskAmountFreeDecimals(row.balance_now, true)} </span></div>
                                                <div>(Sensib.) Cotas: <span style={stylesGreen}>{applyMaskAmountFreeDecimals(row.qtd_quotas_sensibilized_final, false, 5)}</span> / Valor: <span style={stylesGreen}>{applyMaskAmountFreeDecimals(row.pl, true)}</span></div>
                                                <div>Dif. Cotas:<span style={stylesRed}>{applyMaskAmountFreeDecimals(row.quota_amount_now - row.qtd_quotas_sensibilized_final, false, 5)}</span> / Dif. Valor: <span style={stylesRed}>{applyMaskAmountFreeDecimals(row.pl - row.balance_now, true)}</span></div>
                                                {
                                                    row && isPrivateCdiTitle(row) && row.qtd_quota && row.cdb_quota_value ?
                                                        <div>
                                                            {
                                                                row.transactions?.map((transaction, index) => (
                                                                    <div style={{ color: unoTheme.warningColorStrong }}>CDB CALC QTD - MOV{index + 1}: {transaction.quota_value_transaction_calc}</div>
                                                                ))
                                                            }
                                                            <div style={{ color: unoTheme.mainColor }}>CDB CALC VALOR: {row.qtd_quota + " x " + row.cdb_quota_value + ' = ' + applyMaskAmountFreeDecimals(row.qtd_quota * row.cdb_quota_value)}</div>
                                                        </div>
                                                        : null
                                                }
                                            </>
                                    }
                                </div>
                        }
                    </>
            }

        </Alert>
    );
}

/**
 * My main alert
 * @param {string} show 
 * @param {string} type
 * @param {string} message
 * @returns {Object} Alert
 */
export default function MyAlertBalance(props) {

    const classes = useStyles();

    const { row, action, role } = props

    return (
        <div className={classes.alertBalance}>
            {getAlertBalanceContent(row, action, role)}
        </div>
    );
}